import React from "react";
import MainLayout from "../../layouts/MainLayout";
import UsersRegister from "./components/UsersRegister";

function onClickButton() {
  window.location = "/signup";
}

function UsersPage() {
  return (
    <MainLayout>
      {/* Dashboard actions */}
      <div className="sm:flex justify-content-end sm:items-center mb-8">
        <button
          className="btn bg-blue-500 hover:bg-blue-600 text-white"
          onClick={onClickButton}
        >
          <svg
            className="w-4 h-4 fill-current opacity-50 flex-shrink-0"
            viewBox="0 0 16 16"
          >
            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
          </svg>
          <p className="hidden xs:block ml-2">Nuevo Usuario</p>
        </button>
      </div>

      <div className="grid grid-cols-12 gap-6">
        <UsersRegister />
      </div>
    </MainLayout>
  );
}

export default UsersPage;
